<template>
    <div>
      <div class="container">
        <div class="box">
            <div class="header">
            </div>
              <v-img src="@/assets/logo_login.png" max-height="300"  />
              <h1 class="text-center">BIENVENIDO</h1>
            </div>
        </div>
    </div>
  </template>

  <script>
  export default {
    name:"Dashboard"
  }
  </script>

